// src/components/pages/layout/LayoutAdmin.tsx

import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SidebarAdmin from './SidebarAdmin';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0, x: 20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

const LayoutAdmin: React.FC = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('id_usuario') || '';

  // Redirige al login si no hay userId
  useEffect(() => {
    if (!userId) navigate('/');
  }, [userId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex relative">
      <SidebarAdmin />

      <motion.main
        className="flex-1 w-full max-w-full overflow-x-hidden px-4 py-4 sm:px-6 md:px-8"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Outlet />
      </motion.main>
    </div>
  );
};

export default LayoutAdmin;
